import SeletorDeCiclo, { CicloDoSeletor } from 'components/ui/seletor-de-ciclo';
import { FOCO_VISIVEL } from 'utils/foco';

interface CabecalhoDaComposicaoProps {
  cicloId?: string;
  cicloTitulo?: string;
  opcoes: CicloDoSeletor[];
  onCiclo: (id: string) => void;
}

/** "Composição do extrato | Ciclo X" e o seletor de ciclo (PREM-05). */
export default function CabecalhoDaComposicao({ cicloId, cicloTitulo, opcoes, onCiclo }: CabecalhoDaComposicaoProps) {
  return (
    <div className="mb-3 mt-[26px] flex flex-wrap items-center justify-between gap-5">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <h2 tabIndex={0} className={`m-0 font-display text-[19px] font-bold leading-[normal] text-brand-blue-dark ${FOCO_VISIVEL}`}>
          Composição do extrato
        </h2>
        <span aria-hidden="true" className="text-content-soft">
          |
        </span>
        {/* SPEC_DEVIATION: `brand-blue-dark` (design `brand-blue`, 4,35–4,44:1 em 17px sobre o fundo da página). */}
        <span tabIndex={0} className={`font-display text-[17px] font-bold text-brand-blue-dark ${FOCO_VISIVEL}`}>
          Ciclo {cicloTitulo}
        </span>
      </div>
      <SeletorDeCiclo ciclos={opcoes} valor={cicloId} onChange={onCiclo} className="w-full sm:w-[264px]" />
    </div>
  );
}
